import { useOrgSelfServeInfo } from '@hcs/self-serve-info';

import { OrgPricingProductProps, OrgProductPricing } from './OrgProductPricing';

export const OrgPricingAgileSuite = ({
  capabilityKey,
  ...props
}: OrgPricingProductProps) => {
  const { data: ssInfo } = useOrgSelfServeInfo();
  const capabilityPricing = ssInfo?.self_serve_plan?.costs?.[capabilityKey];
  if (!capabilityPricing) return null;
  return (
    <OrgProductPricing
      unitDescriptor="address"
      unitDescriptorPlural="reports"
      actionDescriptor=""
      unitPrice={capabilityPricing.price}
      includedInTier={capabilityPricing.included_units}
      disclaimer={
        capabilityKey !== 'om-vr' &&
        'Onsite inspections, BPOs, and Agile Evaluations may also incur additional cancellation and/or rush charges.'
      }
      {...props}
    />
  );
};
